// extracted by mini-css-extract-plugin
export default {"container":"TrainingMaterial_container__ogb20","title":"TrainingMaterial_title__ROX0-","flexBox":"TrainingMaterial_flexBox__gxmea","flexItem":"TrainingMaterial_flexItem__Ye68I"};